(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["cro-reviews-anchor"] && !Shopify.designMode) return;
  try {
    (function () {
    var SELECTORS = [
      '[id*="vitals_reviews_carousel"]',
      '.Vtl-ReviewsCarousel',
      '[data-vtl-el="reviews-carousel"]'
    ];

    function findReviews() {
      for (var i = 0; i < SELECTORS.length; i++) {
        var el = document.querySelector(SELECTORS[i]);
        if (el && el.offsetParent !== null) return el;
      }
      return null;
    }

    function wire(link) {
      var target = findReviews();
      if (!target) return false;

      link.hidden = false;
      link.addEventListener('click', function (event) {
        event.preventDefault();
        var current = findReviews() || target;
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        current.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        current.setAttribute('tabindex', '-1');
        current.focus({ preventScroll: true });
      });
      return true;
    }

    function init() {
      var links = document.querySelectorAll('[data-cro-reviews-anchor]:not([data-cro-wired])');
      Array.prototype.forEach.call(links, function (link) {
        link.setAttribute('data-cro-wired', '1');
        if (wire(link)) return;
        // Vitals inietta il carosello dopo il load: riprova per ~8s, poi lascia perdere.
        var tries = 0;
        var timer = setInterval(function () {
          tries++;
          if (wire(link) || tries > 16) clearInterval(timer);
        }, 500);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
